export const LOCAL_HOST_FRAGMENTS: readonly string[] = ["localhost", "192.168"];
